'use client';
import { hideModal, showToast } from '@/redux/navigationSlice';
import { refreshDocumentsAfterDelete } from '@/redux/prospectDataSlice';
import { RootState } from '@/redux/store';
import { Button, Stack } from '@mui/material';
import { deleteFile } from '@repo/backoffice-api';
import { useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const DeleteFile = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const { prospectId } = useSelector((state: RootState) => state.prospectData) || '';
  const { id: documentId, documentType, title, required } = useSelector((state: RootState) => state.documentData);
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleFileDelete = useCallback(async () => {
    let notAuth = false;
    try {
      setLoading(true);
      if (!documentId) throw new Error('Document key is missing');
      if (!prospectId) throw new Error('Prospect key is missing');
      const response = await deleteFile({ prospectId, documentId });
      if (response.notAuth) {
        notAuth = true;
        dispatch(showToast({ text: 'Usuario no autenticado', kind: 'error' }));
        throw new Error('User not authenticated');
      }
      if (response.softError || response.hardError || response.message) {
        dispatch(showToast({ text: 'Error al eliminar el documento', kind: 'error' }));
        throw new Error('Error deleting file: ' + response.message);
      }
      dispatch(showToast({ text: 'Documento eliminado correctamente', kind: 'success' }));
      dispatch(refreshDocumentsAfterDelete({ documentType, title, required }));
    } catch (error) {
      console.error('Error deleting file:', error);
    } finally {
      if (notAuth) {
        router.push('/login');
      }
      setLoading(false);
      dispatch(hideModal());
    }
  }, [documentId, prospectId, dispatch, documentType, title, required, router]);

  const handleCancel = useCallback(() => dispatch(hideModal()), [dispatch]);

  return (
    <Stack direction="row" gap={2} width="100%" mt={2} justifyContent="center">
      <Button variant="outlined" onClick={handleCancel}>
        Cancelar
      </Button>
      <Button loading={loading} onClick={handleFileDelete}>
        Eliminar
      </Button>
    </Stack>
  );
};
